import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Menu, Icon, Dropdown, Button, Tabs } from "ant-design-vue";
import { ApplicationViews, LanguageSkill, VcsMenuCategory, VcsMenuCategoryPermission } from "@/util/enum";
import { Paths } from "@/util/paths";
import { isLinkVisible } from "@/util/func";
import { getModule } from "vuex-module-decorators";
import AppSettings from "@/modules/app-settings";
import { ChildNavigationLocale } from "@/locales/localeid";
import { fmtMsg, GLUtil } from "commonui";
import TitleListState from "@/modules/title-list";
import { AppMenuItem } from "@/util/constants";

const { Item } = Menu;

export interface ChildNavigationRef {
	setSelectedMenu: () => void;
}

@Component({
	components: {
		Dropdown,
		AppMenu: Menu,
		AppMenuItem: Item,
		Icon,
		Button,
		"a-tabs": Tabs,
		"a-tab-pane": Tabs.TabPane
	}
})
export default class ChildNavigation extends Vue {
	@Prop() public currentView!: ApplicationViews;
	@Prop() public pathModifier!: (path: string) => string;
	@Prop() public isDisabled!: (path: string) => boolean;
	@Prop() public showBackButton?: boolean;
	@Prop() public menuItems?: AppMenuItem[];
	public appSetting = getModule(AppSettings) as AppSettings;
	public titleListModule = getModule(TitleListState);
	public menuSelectedKeys = [this.appSetting.childMenuSelected];

	public backButtonRoute?: string | null = null;

	@Watch("appSetting.childMenuSelected")
	setSelectedMenu() {
		this.menuSelectedKeys = [this.appSetting.childMenuSelected];
	}

	get applicationViews() {
		return ApplicationViews;
	}

	get applicationPaths() {
		return Paths;
	}

	get vcsMenuCategory() {
		return VcsMenuCategory;
	}

	get vcsMenuPermissionCategory() {
		return VcsMenuCategoryPermission;
	}

	get childNavigationLocale() {
		return ChildNavigationLocale;
	}

	get isCurriculumView() {
		return this.currentView === ApplicationViews.Components;
	}

	@Watch("$route")
	setBackButton() {
		const isLanguageFunction = this.$route.fullPath.includes(Paths.LanguageFunctions);
		const routeLevel = this.$route.matched.length;
		if (routeLevel > 2 && !isLanguageFunction) {
			this.backButtonRoute = this.$route.matched[routeLevel - 2].path;
		} else {
			this.backButtonRoute = null;
		}
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	beforeRouteEnter() {}

	created() {
		this.setBackButton();
		// if (this.currentView === this.applicationViews.TextGuardian) {
		// 	if (
		// 		[
		// 			this.applicationViews.Text
		// 			// this.applicationViews.Subtitles,
		// 			// this.applicationViews.Components,
		// 			// this.applicationViews.TalkMode
		// 			// this.applicationViews.TitlePhraseList
		// 		].includes(this.appSetting.childMenuSelected)
		// 	) {
		// 		this.menuSelectedKeys = [this.applicationViews.TitleList];
		// 	} else if (
		// 		[
		// 			this.applicationViews.TagList,
		// 			this.applicationViews.TagUsageStatistics,
		// 			this.applicationViews.TagUsageDetails
		// 		].includes(this.appSetting.childMenuSelected)
		// 	) {
		// 		this.menuSelectedKeys = [this.applicationViews.TagSearch];
		// 	}
		// }
	}

	get showTeachingPlanTabs() {
		console.log(
			"this.titleListModule.isSubCategorySupportResource",
			this.titleListModule.isSubCategorySupportResource
		);
		return this.titleListModule.allowTeachingPlan && !this.titleListModule.isSubCategorySupportResource;
	}

	get showREPPlanTabs() {
		return this.titleListModule.allowRepPlan && !this.titleListModule.isSubCategorySupportResource;
	}

	get showManageChapters() {
		return this.titleListModule.isParent;
	}

	get showFocusWordsTab() {
		return this.titleListModule.editedContentDetails.languageSkillId == LanguageSkill.Read;
	}

	get isComponentSupportResource() {
		return !this.titleListModule.isSubCategorySupportResource;
	}

	showLink(menuId: VcsMenuCategory, permissionId?: VcsMenuCategoryPermission, superMenuId?: VcsMenuCategory) {
		return isLinkVisible(menuId, permissionId, superMenuId);
	}

	customBinding(path: string) {
		if (path === Paths.Text && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.EditText, { id: this.titleListModule.editedContentId });
		}
		if (path === Paths.ContentObjective && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.ContentObjective, { id: this.titleListModule.editedContentId });
		}
		if (path === Paths.ContentExposure && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.ContentExposure, { id: this.titleListModule.editedContentId });
		}
		if (path === Paths.REP && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.REP, { id: this.titleListModule.editedContentId });
		}
		if (path === Paths.TitlePhraseList && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.TitlePhraseList, { id: this.titleListModule.editedContentId });
		}
		if (path === Paths.ComponentConversation && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.ComponentConversation, { id: this.titleListModule.editedContentId });
		}
		if (path === Paths.EditManageChapters && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.EditManageChapters, { id: this.titleListModule.editedContentId });
		}
		if (path === Paths.Media && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.Media, { id: this.titleListModule.editedContentId });
		}
		if (path === Paths.NonCurriculumComponentsText && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.NonCurriculumComponentsEditText, {
				id: this.titleListModule.editedContentId
			});
		}
		if (path === Paths.NonCurriculumComponentsMedia && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.NonCurriculumComponentsMedia, {
				id: this.titleListModule.editedContentId
			});
		}
		if (path === Paths.FocusWordsTab && this.titleListModule.editedContentId.length) {
			return GLUtil.pathStringify(Paths.FocusWordsTab, {
				id: this.titleListModule.editedContentId
			});
		}
		return path;
	}

	handleReportMenuClick(e: any) {
		const viewPathMap = {
			[ApplicationViews.ComponentObjectives]: this.applicationPaths.ComponentObjectives,
			[ApplicationViews.UnitOverview]: this.applicationPaths.UnitOverview,
			[ApplicationViews.VpcOverview]: this.applicationPaths.VpcOverview,
			[ApplicationViews.ComponentToObjective]: this.applicationPaths.ComponentToObjective,
			[ApplicationViews.MasteryQuestionToObjective]: this.applicationPaths.MasteryQuestionToObjective,
			[ApplicationViews.FocusWordsByChapter]: this.applicationPaths.FocusWordsByChapter,
			[ApplicationViews.MediaChangeImpact]: this.applicationPaths.MediaChangeImpact
		};

		const path = viewPathMap[e] || this.applicationPaths.ScopeSequence;

		this.appSetting.setChildMenu(e.key);
		this.$router.push(path);
	}

	handleMenuClick(e: any) {
		// e.key
		//console.log(this.menuSelectedKeys);
		this.appSetting.setChildMenu(e.key);
	}
}
